export default __webpack_public_path__ + "static/media/bike.4289ac04.jpeg";